import classNames from 'classnames'

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()

const IconButton = ({ className = '', isActive = false, alt, iconPath, iconActivePath, onClick }) => {
    const title = capitalizeFirstLetter(alt)
    const btnClass = classNames({
        'nav-icon-button': !isActive,
        'nav-icon-button-active': isActive,
        [className]: true,
    })
    return (
        <button title={title} className={btnClass} onClick={onClick}>
            <div>
                <img alt={alt} src={iconPath} />
                <img alt={alt} src={iconActivePath} />
            </div>
        </button>
    )
}

IconButton.propTypes = {
    isActive: PropTypes.bool,
    alt: PropTypes.string.isRequired,
    iconPath: PropTypes.string.isRequired,
    iconActivePath: PropTypes.string.isRequired,
    onClick: PropTypes.func,
}

export default IconButton
